import React from 'react';
import { TrackedKaiChat } from '@/components/attention/TrackedKaiChat';
import { useTranslation } from 'react-i18next';
import ReactMarkdown from 'react-markdown';

interface ChatHistoryProps {
  onSubmit: (question: string) => void;
  onResponse: (response: string) => void;
  context: string;
  chat: { question: string; answer: string }[];
}

const ChatHistory = ({ onSubmit, onResponse, context, chat }: ChatHistoryProps) => {
  const { t } = useTranslation();
  return (
    <div className="mt-6 border-t pt-4">
      <h4 className="font-medium mb-4">{t('ai.askQuestion')}</h4>
      <TrackedKaiChat 
        onSubmit={onSubmit}
        onResponse={onResponse}
        context={context}
      />
      
      {chat.map((chatItem, index) => (
        <div key={`chat-${index}-${chatItem.question.substring(0, 20)}`} className="mt-4 bg-muted p-4 rounded-lg space-y-3">
          <div className="flex items-start gap-2">
            <span className="font-semibold text-primary shrink-0">Du:</span>
            <p className="text-foreground">{chatItem.question}</p>
          </div>
          <div className="flex items-start gap-2">
            <span className="font-semibold text-primary shrink-0">Kai:</span>
            <div className="prose prose-sm max-w-none text-foreground dark:prose-invert">
              <ReactMarkdown>{chatItem.answer}</ReactMarkdown>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ChatHistory;
